module.exports = __webpack_public_path__ + "img/shrtnrlight.8d37ede8.png";